import React, { useState } from 'react';

const Wholesale = () => {
  const [formData, setFormData] = useState({
    businessName: '',
    contactName: '',
    email: '',
    phone: '',
    businessType: '',
    message: ''
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // In a real application, this would send data to a backend
    console.log('Wholesale inquiry submitted:', formData);
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 5000);
  };

  return (
    <div className="min-h-screen bg-gray-50 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-forest-green mb-4">
            Wholesale Partnerships
          </h1>
          <p className="text-xl text-gray-700">
            Partner with NorthPet for your business needs
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Info Section */}
          <div className="bg-white rounded-lg shadow-lg p-8">
            <h2 className="text-3xl font-bold text-forest-green mb-6">
              Why Partner with NorthPet?
            </h2>
            <div className="space-y-6">
              <div className="flex items-start">
                <div className="flex-shrink-0 bg-moss-green text-white rounded-full w-10 h-10 flex items-center justify-center text-xl font-bold mr-4">
                  1
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-forest-green mb-2">
                    Quality Products
                  </h3>
                  <p className="text-gray-600">
                    Access to our full range of eco-conscious, adventure-ready pet supplies 
                    at competitive wholesale prices.
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="flex-shrink-0 bg-moss-green text-white rounded-full w-10 h-10 flex items-center justify-center text-xl font-bold mr-4">
                  2
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-forest-green mb-2">
                    Flexible Terms
                  </h3>
                  <p className="text-gray-600">
                    We work with businesses of all sizes, from local pet stores to large 
                    retail chains, with flexible order quantities and payment terms.
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="flex-shrink-0 bg-moss-green text-white rounded-full w-10 h-10 flex items-center justify-center text-xl font-bold mr-4">
                  3
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-forest-green mb-2">
                    Marketing Support
                  </h3>
                  <p className="text-gray-600">
                    Receive marketing materials, product displays, and promotional support 
                    to help you sell NorthPet products effectively.
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="flex-shrink-0 bg-moss-green text-white rounded-full w-10 h-10 flex items-center justify-center text-xl font-bold mr-4">
                  4
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-forest-green mb-2">
                    Reliable Supply Chain
                  </h3>
                  <p className="text-gray-600">
                    Count on consistent product availability and timely deliveries to keep 
                    your inventory stocked.
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-8 p-6 bg-forest-green text-white rounded-lg">
              <h3 className="text-xl font-bold mb-3">Who We Work With</h3>
              <ul className="space-y-2">
                <li className="flex items-center">
                  <span className="mr-2">🏪</span>
                  <span>Pet Supply Stores</span>
                </li>
                <li className="flex items-center">
                  <span className="mr-2">🏕️</span>
                  <span>Outdoor Retail Shops</span>
                </li>
                <li className="flex items-center">
                  <span className="mr-2">🏢</span>
                  <span>Veterinary Clinics</span>
                </li>
                <li className="flex items-center">
                  <span className="mr-2">🛒</span>
                  <span>Online Retailers</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Contact Form */}
          <div className="bg-white rounded-lg shadow-lg p-8">
            <h2 className="text-3xl font-bold text-forest-green mb-6">
              Get in Touch
            </h2>
            {submitted ? (
              <div className="bg-moss-green text-white p-6 rounded-lg text-center">
                <div className="text-5xl mb-4">✓</div>
                <h3 className="text-2xl font-bold mb-2">Thank You!</h3>
                <p>
                  We've received your wholesale inquiry and will get back to you 
                  within 1-2 business days.
                </p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label htmlFor="businessName" className="block text-gray-700 font-semibold mb-2">
                    Business Name *
                  </label>
                  <input
                    type="text"
                    id="businessName"
                    name="businessName"
                    required
                    value={formData.businessName}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-forest-green"
                    placeholder="Your Business Name"
                  />
                </div>

                <div>
                  <label htmlFor="contactName" className="block text-gray-700 font-semibold mb-2">
                    Contact Name *
                  </label>
                  <input
                    type="text"
                    id="contactName"
                    name="contactName"
                    required
                    value={formData.contactName}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-forest-green"
                    placeholder="Your Name"
                  />
                </div>

                <div>
                  <label htmlFor="email" className="block text-gray-700 font-semibold mb-2">
                    Email *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-forest-green"
                    placeholder="your@email.com"
                  />
                </div>

                <div>
                  <label htmlFor="phone" className="block text-gray-700 font-semibold mb-2">
                    Phone Number *
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    required
                    value={formData.phone}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-forest-green"
                    placeholder="(555) 123-4567"
                  />
                </div>

                <div>
                  <label htmlFor="businessType" className="block text-gray-700 font-semibold mb-2">
                    Business Type *
                  </label>
                  <select
                    id="businessType"
                    name="businessType"
                    required
                    value={formData.businessType}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-forest-green"
                  >
                    <option value="">Select Type</option>
                    <option value="pet-store">Pet Supply Store</option>
                    <option value="outdoor">Outdoor Retail</option>
                    <option value="veterinary">Veterinary Clinic</option>
                    <option value="online">Online Retailer</option>
                    <option value="other">Other</option>
                  </select>
                </div>

                <div>
                  <label htmlFor="message" className="block text-gray-700 font-semibold mb-2">
                    Message
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    rows="4"
                    value={formData.message}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-forest-green"
                    placeholder="Tell us about your business and wholesale needs..."
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="w-full bg-forest-green text-white px-6 py-4 rounded-lg font-bold text-lg hover:bg-opacity-90 transition duration-300"
                >
                  Submit Inquiry
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Wholesale;
